import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import supabase from '@/utils/supabase';

export default function Login() {
  const handleGoogleAuth = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/lobby`,
      },
    });
    if (error) {
      console.error('Login failed:', error.message);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Card className="flex flex-col items-center justify-center w-150 h-100">
        <CardContent>
          <Button
            size={'lg'}
            onClick={handleGoogleAuth}
            className="text-xl px-12 py-9 cursor-pointer"
          >
            Login with Google
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
